import UnderConstruction from '@/components/common/UnderConstruction'
import { createFileRoute } from '@tanstack/react-router'
import { Sparkles } from 'lucide-react'

export const Route = createFileRoute('/_app/creation/')({
  staticData: {
    title: 'Création',
    icon: Sparkles,
    tab_icon: Sparkles,
    permission: 'creation.employes.view',
    section: 'Creation',
    order: 26,
    description: 'Module de création',
    module: 'creation',
    showInTab: true,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: UnderConstruction,
})
